/**
 * Whether a query failed because the backend answered 404.
 *
 * openapi-react-query throws the response body as it is — NestJS's
 * `{ statusCode, message }` for an HttpException — while a request that never
 * got an answer (no network, a proxy down) throws a TypeError with no status
 * at all. Only the first one means the thing does not exist.
 */
export function isNotFound(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'statusCode' in error && error.statusCode === 404;
}
